export default __webpack_public_path__ + "static/media/gbTAC.fdee210f.png";